import React, {useRef} from 'react'
import PropTypes from 'prop-types'
import {IconButton, Flex, Skeleton, Text, useMultiStyleConfig, VStack} from '@chakra-ui/react'
import {useIntl} from 'react-intl'

import loadable from '@loadable/component'
const ReviewScoreIcon = loadable(() => import('../review/ReviewScoreIcon'))

import {FavouriteFilledIcon, FavouriteIcon} from '../icons/others'
import {useWishlistActions} from '../../hooks/use-wishlist-actions'
import {useWishList} from '../../hooks/use-wish-list'
import {useBooleanCustomPreference} from '../../hooks/use-custom-preference'

const ProductHeader = ({name, product}) => {
    const hideAccountPref = useBooleanCustomPreference('hideAccount')
    const hideAccount = hideAccountPref !== null ? hideAccountPref : false
    const style = useMultiStyleConfig('ProductHeader')
    const {data: wishlist} = useWishList()
    const {formatMessage} = useIntl()
    const isFavouriteLoading = useRef(false)
    const {toggleWishlistItem, isProductInWishlist} = useWishlistActions(wishlist)
    const isInWishlist = isProductInWishlist(product?.c_subModelIdentifier)
    const localizedProductName = product.name ?? product.productName
    const isFavourite = isProductInWishlist(product?.c_subModelIdentifier ?? product?.productId)
    return (
        <Skeleton isLoaded={name} w="100%" data-testid="product-header">
            <VStack {...style.container}>
                <Flex justify="space-between" w="100%">
                    <Text as="h1" {...style.title}>
                        {name}
                    </Text>
                    {!hideAccount && (
                        <IconButton
                            key="wishlist-button"
                            paddingInlineStart={0}
                            paddingInlineEnd={0}
                            h="auto"
                            minWidth="auto"
                            data-testid="wishlist-button"
                            icon={
                                isInWishlist ? (
                                    <FavouriteFilledIcon
                                        {...style.favSvgSolid}
                                        data-product-code={product?.id}
                                    />
                                ) : (
                                    <FavouriteIcon
                                        {...style.favSvg}
                                        data-product-code={product?.id}
                                    />
                                )
                            }
                            onClick={() => toggleWishlistItem(product, isFavouriteLoading)}
                            className="js-wishlist-add"
                            data-product-code={product?.id}
                            aria-label={
                                isFavourite
                                    ? formatMessage(
                                          {
                                              id: 'product_tile.assistive_msg.remove_from_wishlist',
                                              defaultMessage: 'Remove {product} from wishlist',
                                          },
                                          {product: localizedProductName},
                                      )
                                    : formatMessage(
                                          {
                                              id: 'product_tile.assistive_msg.add_to_wishlist',
                                              defaultMessage: 'Add {product} to wishlist',
                                          },
                                          {product: localizedProductName},
                                      )
                            }
                        ></IconButton>
                    )}
                </Flex>
                {product?.c_categoryName && (
                    <Text
                        // dangerouslySetInnerHTML={{__html: product?.shortDescription}}
                        {...style.description}
                    >
                        {product.c_categoryName}
                    </Text>
                )}

                <ReviewScoreIcon
                    id={product?.c_subModelIdentifier || product?.id}
                    bvData={'rating_summary'}
                />
                <Text {...style.id}>{product?.c_subModelIdentifier || product?.id}</Text>
            </VStack>
        </Skeleton>
    )
}

ProductHeader.propTypes = {
    name: PropTypes.string,
    product: PropTypes.object,
    handleWishlistItem: PropTypes.func,
    isWishlistLoading: PropTypes.bool,
}

export default ProductHeader
